import apiClient from '@/services/axios'

export const getAssets = async (
  payload,
  customerId = '',
  locationId = '',
  roomId = '',
  status = '',
  userId = '',
  role = '',
  name,
  isApproval,
) => {
  // console.log(payload)
  // console.log(customerId)
  // console.log(locationId)
  // console.log(roomId)
  // console.log(userId)
  // console.log(role, 'ini??')
  // console.log(name)
  // console.log(status)
  const res = await apiClient.get(`/admin/assets`, {
    params: {
      ...payload,
      customerId: customerId !== 'Filter Customer' ? customerId : '',
      locationId: locationId !== 'Filter Lokasi' ? locationId : '',
      roomId: roomId !== 'Filter Ruang' ? roomId : '',
      status: status !== 'Filter Status Asset' ? status : '',
      role,
      name,
      userId: userId ? userId : '',
      isApproval,
    },
  })
  // const res = await apiClient.get(`/admin/assets?type=${type}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAssetsById = async id => {
  const res = await apiClient.get(`/admin/assets/${id}`)
  if (res) {
    console.log(res, 'inidistore')
    return res.data
  } else {
    return []
  }
}
export const getAssetCategory = async () => {
  const res = await apiClient.get('/admin/assetsCategory')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAssetTypeCategory = async () => {
  const res = await apiClient.get('/admin/category-type/assets')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const createAssetTypeCategory = async name => {
  const res = await apiClient.post('/admin/category-type/assets', {
    name,
  })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const updateAssetTypeCategory = async (name, id) => {
  const res = await apiClient.patch('/admin/category-type/assets/' + id, {
    name,
  })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const deleteAssetTypeCategory = async id => {
  const res = await apiClient.delete('/admin/category-type/assets/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAssetSubCategory = async () => {
  const res = await apiClient.get('/admin/category/assets')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const createAssetSubCategory = async payload => {
  const res = await apiClient.post('/admin/category/assets', payload)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const updateAssetSubCategory = async payload => {
  const res = await apiClient.patch('/admin/category/assets/' + payload.id, payload)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const deleteAssetSubCategory = async id => {
  const res = await apiClient.delete('/admin/category/assets/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const editAssetsById = async (id, payload) => {
  console.log('disinicuy', id)
  const res = await apiClient.put(`/admin/assets/${id}`, payload)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const deleteAssetsById = async id => {
  const res = await apiClient.delete(`/admin/assets/${id}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const editStatusAssetsById = async (id, payload) => {
  // console.log('disinicuy', id)
  const res = await apiClient.patch(`/admin/assets/${id}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const approveAssetByEmail = async token => {
  // console.log('disinicuy', id)
  const res = await apiClient.patch(`/email-approval/${token}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const postAssets = async payload => {
  const res = await apiClient.post('/admin/assets', payload)
  if (res) {
    return res.data
  } else {
    return null
  }
}
export const postAssetsBulks = async payload => {
  const res = await apiClient.post('/admin/assetsBulk', payload)
  if (res) {
    return res.data
  } else {
    return null
  }
}

export const getCustomer = async () => {
  const res = await apiClient.get('/admin/customers')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getCategories = async () => {
  const res = await apiClient.get('/admin/category/assets')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const postInfrastructure = async payload => {
  const res = await apiClient.post('/admin/assets/infrastructure', payload)
  if (res) {
    return res.data
  } else {
    return []
  }
}
